export enum METHOD_TYPE {
	GET = "GET",
	POST = "POST"
}
export interface ISearch { 
    value:string,
    regex:boolean
}
export interface IOrder{ 
    dir:string,
    column:number
}
export interface IColumn { 
    data:number,
    summery:number,
    name:string,
    orderable:boolean,
    search:ISearch,
    searchable:boolean
}
export interface IDataTableParam { 
    columns : Array<IColumn>,
    draw : number,
    length:number,
    order:Array<IOrder>
    search: ISearch,
    start:number,
    currentPageIndex?:number,
    searchColumns?:any

}  
export interface IRequestQuery { 
    start?:number,
    length?:number,
    orderByField:any,
    orderType:string,
    filterType?:string,
    search?:string,   
    filterJSONData?: any

}
export interface IDataTableResponse<T,S={}>{
	recordsTotal: number,
	recordsFiltered: number,
	data: T,
    summary?:S,
    postParamObject?:object | any,
    EntityTypeID?:number,
    EntityTypeName?:string,
    permissionActionsID?:Array<number>,
    SampleExcelFile: any
   
}

